<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "app"
};
</script>

<style>
  @import "../node_modules/mdi/css/materialdesignicons.min.css";
  @import "../node_modules/flag-icon-css/css/flag-icon.min.css";
  @import "../node_modules/font-awesome/css/font-awesome.min.css";
</style>

<style lang="scss">
@import "./assets/scss/style";
</style>


// WEBPACK FOOTER //
// src/App.vue